import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-bendidiaoyong",
  "use": "icon-bendidiaoyong-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-bendidiaoyong\"><path d=\"M496 256.1l-64-112L128 144.1c-57-3-64 32-64 48l0 688 896 0 0-624L496 256.1zM112 192.1l288 0 37.3 64L112 256.1 112 192.1zM912 832.1 112 832.1l0-528 800 0L912 832.1z\" p-id=\"3752\" fill=\"#dbdbdb\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bendidiaoyong.svg
// module id = GxOj
// module chunks = 17